<template>
  <div class="d-flex flex-column">
    <div class="flex-row justify-content-between">
      <div v-if="!hasFilter(column)" class="flex-grow-0 pt-0 forgeron-label-container">
        <span class="text-nowrap">
          <label :for="resourceType + '-filter-' + column" class="column-name">
            <attribute-title
              :color="decoration().attributes[column]?.color ?? null"
              :icon-class="decoration().attributes[column]?.iconClass ?? null"
              :options="{
                showText: !decoration().attributes[column]?.hideText,
                showIcon: !!decoration().attributes[column]?.iconClass,
              }"
              :value="getLabel(column, trans)"
            ></attribute-title>
          </label>
        </span>
      </div>
      <div v-else class="flex-row forgeron-filter-container">
        <model-filter
          v-if="hasFilter(column)"
          :column="column"
          :label="getLabel(column, trans)"
          :options="options"
          :resource="resource"
          @update:params="$emit('update:params', params)"
        ></model-filter>
      </div>

      <div v-if="!plain" class="flex-grow-0 forgeron-sort-button">
        <sort-button :column="column" :params="params" :resource-type="resourceType" :sort="sort"></sort-button>
      </div>
    </div>
  </div>
</template>

<script>
import AttributeTitle from '@kanrisha/components/Collection/Common/Adjustments/AttributeTitle';
import ModelFilter from '@kanrisha/components/Collection/Common/Adjustments/ModelFilter';
import SortButton from '@kanrisha/components/Collection/Common/Adjustments/SortButton';

export default {
  components: {
    AttributeTitle,
    ModelFilter,
    SortButton,
  },
  props: {
    resource: { type: Object, default: () => {} },
    options: { type: Object, default: () => {} },
    config: { type: Object, default: () => {} },
    column: { type: String, default: '' },
    resourceType: { type: String, default: '' }, // deprecated: use resource.meta.resourceType
    filter: { type: Object, default: () => {} }, // deprecated: use resource.meta.adjustments.filter
    excludeNull: { type: Object, default: () => {} }, // deprecated
    sort: { type: String, default: () => 'id' }, // deprecated: use resource.meta.adjustments.sort
    meta: { type: Object, default: () => {} }, // deprecated: use resource.meta
    params: { type: Object, default: () => {} },
    plain: { type: Boolean, default: false },
  },
  emits: ['update:params'],
  setup(props) {
    const decoration = () => {
      let localDecoration = props.meta.decoration;
      localDecoration.attributes = localDecoration.attributes ?? {};
      localDecoration.options = localDecoration.options ?? {};

      return localDecoration;
    };

    const getLabel = (column, trans) => {
      if (!props.meta.labels[column]) {
        return trans(
          `models.${props.resourceType}.` +
            (props.meta.elementTypes && props.meta.elementTypes[column] === 'relation' ? 'relations' : 'attributes') +
            `.${column}`
        );
      }

      return props.meta.labels[column];
    };

    const hasFilter = (column) => {
      if (
        props.plain ||
        !(
          props.meta.columns[column] ||
          props.meta.listed[column] === 'relation' ||
          props.meta.listed[column] === 'tags'
        )
      ) {
        return false;
      }

      return (
        props.meta.listed[column] === 'text' ||
        props.meta.listed[column] === 'decimal' ||
        props.meta.listed[column] === 'relation' ||
        props.meta.listed[column] === 'belongs-to' ||
        props.meta.listed[column] === 'enum' ||
        props.meta.listed[column] === 'datetime' ||
        props.meta.listed[column] === 'date' ||
        (props.meta.listed[column] === 'tags' && props.meta.tags?.length)
      );
    };

    return {
      decoration,
      getLabel,
      hasFilter,
    };
  },
};
</script>
